import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const pagePath = location.pathname + location.search;
    console.log('[GA] Page view:', pagePath);

    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: document.title,
    });
  }, [location]);
}
